module.exports = __webpack_public_path__ + "WealthCare Saver HSA Transfer of Assets Form.pdf";